<div class="error-component row">
  <div class="col-12">
    <h1>{{ 'forbidden.forbidden' | translate }}</h1>
    <p class="error rounded p-3">
      <ucs-icon [class]="'blue'" [shape]="'info'" size="24"></ucs-icon>
      <span class="text ms-2">{{ 'forbidden.not-authorized' | translate }}</span>
    </p>
  </div>
</div>
